import { useEffect } from "react";
import Row from "../../../components/Row";
import ViewPackages from "../../../components/packages/ViewPackages";

const CustomerSummary = ({ businessName, businessAddress, userFirstName, userLastName, userEmail, currentCustomerPackages, setCanSubmit }) => {
	useEffect(() => {
		setCanSubmit(true);
	}, [setCanSubmit]);
	
	const getBusinessAddressText = () => {
		return businessAddress.value.replace(/\n/g, "<br/>");
	}

	const getBillingText = () => {
		if (currentCustomerPackages.length > 0 && currentCustomerPackages[0].ResellerName) {
			return `iTEL will bill ${currentCustomerPackages[0].ResellerName} for this customer.`;
		}
		return "";
	};

	return (
		<div>
			<p>
				You are adding a new Customer with the following details. Please make sure the details are correct. <strong>{getBillingText()}</strong><br /><br />
				<strong>{userFirstName.value} {userLastName.value}</strong> will receive an email at {userEmail.value} inviting them to join the ucSKILLS platform.
			</p>
			<Row class="my-4">
				<div className="ap-col col-2">
					<h4 className="no-margin">Main Contact</h4>
				</div>
				<div className="ap-col"><p>{userFirstName.value} {userLastName.value}<br />{userEmail.value}</p></div>
			</Row>
			<Row class="mb-4">
				<div className="ap-col col-2">
					<h4 className="no-margin">Business</h4>
				</div>
				<div className="ap-col">
					<p>{businessName.value}<br /><span className="contents" dangerouslySetInnerHTML={{ __html: getBusinessAddressText() }}></span></p>
				</div>
			</Row>
			<div>
				<ViewPackages selectedPackages={currentCustomerPackages} />
			</div>
		</div>
	);
};

export default CustomerSummary;